import React from 'react';
import { useLenis } from '@studio-freight/react-lenis';

const Up = () => {
  const lenis = useLenis(); 

  const scrollToTop = () => {
    lenis.scrollTo(0, {
      duration: 1.5, 
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    });
  };

  return (
    <div
      className='w-full flex justify-center items-center h-20  cursor-pointer bg-white overflow-hidden group'
      onClick={scrollToTop} 
    >
      <img src='/images/up.svg' className='w-8 opacity-50 group-hover:scale-105 transition-all duration-300' alt="Scroll to top" />
    </div>
  );
};

export default Up;
